import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useWithdrawalProviders } from '@/api';
import { useTranslations } from '@/i18n/TranslationsProvider';
import { ProviderListPanel } from '@/ui/profile';

export const Route = createFileRoute('/profile/withdrawals/')({
  component: ProfileWithdrawalsPage,
});

function ProfileWithdrawalsPage() {
  const { t, i18n } = useTranslation();
  const { selectedLanguage } = useTranslations();
  const navigate = useNavigate();
  const isTranslationReady =
    selectedLanguage === 'en' || i18n.hasResourceBundle(selectedLanguage, 'translation');
  const label = (key: string, fallback: string) =>
    isTranslationReady ? t(key, { defaultValue: fallback }) : fallback;

  const providers = useWithdrawalProviders(true);

  return (
    <div className="flex flex-col gap-4 lg:gap-6">
      <header className="flex flex-col gap-1 lg:gap-2">
        <h1 className="text-[18px] font-bold text-text-primary lg:text-[22px]">
          {label('Withdraw', 'Withdraw')}
        </h1>
        <p className="text-[13px] text-text-secondary">
          {label('Select a payment provider', 'Select a payment provider')}
        </p>
      </header>
      <ProviderListPanel
        providers={providers}
        onSelect={(providerId) => {
          const provider = providers.findById(String(providerId));
          // Legacy: IsRedeposit rows bind to DepositRequest, not WithdrawalRequest.
          if (provider?.IsRedeposit) {
            void navigate({
              to: '/profile/deposits/$providerId',
              params: { providerId: String(providerId) },
              search: { from: 'withdrawals' },
            });
            return;
          }
          void navigate({
            to: '/profile/withdrawals/$providerId',
            params: { providerId: String(providerId) },
          });
        }}
      />
    </div>
  );
}
